var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import CrossWindowBase from '../messaging/base';
/*
 * Handles to cross window request for the order
 */
export default class CrossWindowShop extends CrossWindowBase {
    constructor(_window, _shop) {
        super({
            window: _window,
            scope: 'shop',
        });
        /**
         * Data received from the client on connect
         */
        this.client = null;
        /**
         * Pass the tweak config to the client on connect
         */
        this._initData = null;
        this.shop = _shop;
        this._initData = {
            localization: {
                currency: this.shop.data.currency,
                locale: this.shop.data.company.locale,
            },
            initErrors: {
                valid: !this.shop.initErrors.length,
                errors: this.shop.initErrors,
            },
        };
        // Listen to all shop initialization events
        this.shop.onLog(['shop', 'init'], (path, payload) => this._initError(path, payload));
        this.shop.onLog(['shop', 'overwriteData'], (path, payload) => this._initError(path, payload));
        this.shop.onLog(['shop', 'updateData'], (path, payload) => this._initError(path, payload));
        // Listen to all shop events
        this.shop._eventBus.on(['shop'], () => this._updateShopData());
        // Listen to all cart events
        this.shop._eventBus.on(['cart'], (path, data) => {
            // Don't propagate loading state, as generating and passing through
            // the cart data is too much overhead.
            if (data && data.busy === true) {
                return;
            }
            this._updateCartData();
        });
        // Listen to seats events
        this.shop._eventBus.on(['seats'], (path) => {
            this._sendMessage({
                action: 'seats',
                scope: 'shop',
                data: {
                    state: path[1],
                },
            });
        });
        this.shop._eventBus.on(['cart', 'locale'], (path, locale) => {
            this._sendMessage({
                action: 'locale',
                scope: 'shop',
                data: { locale },
            });
        });
        // Listen for notifications
        this.shop._eventBus.on(['notification'], (path, data) => {
            this._sendMessage({
                action: 'notification',
                data,
            });
        });
        // Listen for client-notifications (only meant for clients)
        this.shop._eventBus.on(['client-notification'], (path, data) => {
            this._sendMessage({
                action: 'client-notification',
                data,
            });
        });
        // Listen for router changes
        this.shop._eventBus.on(['router'], (path, data) => {
            this._sendMessage({
                action: 'router',
                data,
            });
        });
    }
    sendCustomMessage(action, data) {
        this._sendMessage({
            action: 'custom',
            scope: 'shop',
            data,
        });
    }
    /**
     * Handled messaging for the OpenTicketBase class
     * @param event - data from the event
     */
    onMessage(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const message = event.data;
            if (message.scope !== 'client') {
                return;
            }
            yield this.onClientMessage(event);
        });
    }
    /**
     *  Handle established connection data
     *  @param data - The data that is received
     */
    onConnect(data) {
        const _super = Object.create(null, {
            onConnect: { get: () => super.onConnect }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.onConnect.call(this, data);
            this.client = data;
            if (data && Object.prototype.hasOwnProperty.call(data, 'debugMode')) {
                this.shop.setDebugMode(!!data.debugMode);
            }
        });
    }
    /**
     * Handle incoming messages
     * @param event - Received message
     */
    onClientMessage(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const message = event.data;
            // TODO: handle all cases
            try {
                switch (message.type) {
                    case 'ticket':
                        switch (message.action) {
                            case 'add':
                                yield this.shop.cart.addTicket(message.guid);
                                break;
                            case 'remove':
                                yield this.shop.cart.removeTicket(message.guid);
                                break;
                        }
                        break;
                    case 'product':
                        switch (message.action) {
                            case 'add':
                                yield this.shop.cart.addProduct(message.guid);
                                break;
                            case 'remove':
                                yield this.shop.cart.removeProduct(message.guid);
                                break;
                        }
                        break;
                    case 'coupon':
                        switch (message.action) {
                            case 'add':
                                yield this.shop.cart.addCoupon(message.code);
                                break;
                            case 'remove':
                                yield this.shop.cart.removeCoupon(message.code);
                                break;
                        }
                        break;
                    case 'booker_information':
                        this.shop.cart.setBookerInformation(message.data);
                        break;
                    case 'static_settings':
                        this.shop.events.emit(['settings', 'static'], message.data);
                }
            }
            catch (e) {
                this._sendError(`${e}`);
            }
        });
    }
    /**
     * Send an update for init errors
     */
    _initError(_, payload) {
        this._sendMessage({
            action: 'init',
            scope: 'shop',
            data: JSON.parse(JSON.stringify({
                valid: !this.shop.initErrors.length,
                errors: this.shop.initErrors,
                session: payload.session,
                id: payload.id,
                slug: payload.slug,
                message: payload.message,
            })),
        });
    }
    /**
     * Send an update event containing the shop data
     */
    _updateShopData() {
        this._sendMessage({
            action: 'update',
            scope: 'shop',
            data: JSON.parse(JSON.stringify(this.shop.data)),
        });
    }
    /**
     * Send an update event containing the cart data
     */
    _updateCartData() {
        const tickets = {};
        for (const cartTicket of Object.values(this.shop.cart.flatItems.tickets)) {
            const guid = cartTicket.item.guid;
            tickets[guid] = this.shop.cart.getTicketInfo(guid);
        }
        const products = {};
        for (const cartProduct of Object.values(this.shop.cart.flatItems.products)) {
            const guid = cartProduct.item.guid;
            products[guid] = this.shop.cart.getProductInfo(guid);
        }
        const coupons = {};
        for (const appliedCoupon of Object.values(this.shop.cart.getAppliedCoupons())) {
            const guid = appliedCoupon.item.guid;
            coupons[guid] = this.shop.cart.getCouponInfo(guid);
        }
        const checkout_details = JSON.parse(JSON.stringify(this.shop.cart.checkout_details));
        this._sendMessage({
            action: 'update',
            scope: 'cart',
            data: {
                tickets,
                products,
                coupons,
                checkout_details,
            },
        });
    }
}
//# sourceMappingURL=messaging.js.map